module.exports = __webpack_public_path__ + "static/media/2handslogo.f93f94d3.png";